import {useParams} from "react-router-dom";
import classes from "./ReleaseActivityPage.module.css";
import settingsClasses from "../PlatformSetting/Settings.module.css";
import {
    ACTIVITY_TYPE_PLACEHOLDER,
    ATTENDANCE,
    ATTENDANCE_LENGTH_SETTING_DESC,
    ATTENDANCE_LENGTH_SETTING_TEXT, ATTENDANCE_TIME_LIMIT_TEXT,
    BACK_TEXT,
    COUNTDOWN_TIMER_LABEL, DEFAULT_COUNT_DOWN_TIME_LIMIT,
    EMAIL_NOTIFICATION_OPTIONS, EMAIL_NOTIFICATIONS, EMAIL_NOTIFICATIONS_TIMER,
    MINIMUM_POLL_TIME_LIMIT,
    MODAL_CANCEL_TEXT,
    NOTIFICATION_DROPDOWN_PLACEHOLDER,
    PARTICIPANT_TIME_INTRO,
    PARTICIPANT_TIME_INTRO_SCHEDULE,
    POLL_COUNTDOWN_TIMER_DESCRIPTION,
    POLL_COUNTDOWN_TIMER_EMPHASIS,
    POLL_LENGTH_SETTING_DESC,
    POLL_LENGTH_SETTING_TEXT,
    POLL_SHARE_MODE,
    POLL_TEXT, POLL_TIME_LIMIT_TEXT,
    POLL_TYPE,
    RELEASE, RELEASE_ACTIVITY_OPTIONS_DESCRIPTION,
    RELEASE_ACTIVITY_VIEW,
    SCHEDULE,
    SCHEDULED_POLL_EMAIL_NOTIFICATION_DISABLED_REASON,
    SCHEDULED_RELEASE_OPTION_DESCRIPTION_WITH_EMAIL,
    SCHEDULED_RELEASE_OPTION_DESCRIPTION_WITHOUT_EMAIL, SYNC_LMS_OPTIONS,
    USER_SETTINGS,
    YUJA_DROPDOWN_SIZE
} from "../../utils/constants";
import {ReactComponent as RELEASE_ICON} from "../../images/release_options_icon.svg";
import {ReactComponent as BACK} from "../../images/arrow-left-purple.svg"
import {ReactComponent as INFO_ICON} from "../../images/info_icon.svg"
import {ReactComponent as RELEASE_ENTIRELY_IMAGE} from "./images/release_entriely_image.svg"
import {ReactComponent as RELEASE_BY_QUESTION_IMAGE} from "./images/release_by_question_image.svg"
import {ReactComponent as RELEASE_SCHEDULED_IMAGE} from "./images/release_scheduled_image.svg"
import {ReactComponent as ARROW_RIGHT} from "../../images/arrow_right_black.svg";

import React, {useState} from "react";
import YuJaButton from "../../components/standardization/YuJaButton";
import {
    deCapitalizeWord,
    getShortName,
    isShareByQuestionActivity,
    notifyError,
    notifySuccess,
    transferUserSettings
} from "../../utils/helpers";
import {
    INVALID_SCHEDULE_END_DATE_ERROR,
    INVALID_SCHEDULE_END_TIME_ERROR,
    INVALID_SCHEDULE_START_TIME_ERROR,
    INVALID_TIME_LIMIT_ERROR, MINIMUM_COUNT_DOWN_SETTING_ERROR,
    MINIMUM_POLL_TIME_LIMIT_SETTING_ERROR,
    MISSING_SCHEDULE_START_END_TIME_ERROR,
    SCHEDULE_POLL_START_END_GAP_ERROR
} from "../../utils/toast-message-constants";
import {YuJaDropdown} from "../../components/standardization/YuJaDropdown";
import {PollApiCalls} from "../../apis/PollApiCalls";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {LTIApiCalls} from "../../apis/LTIApiCalls";
import TimeLimitInput from "../../components/TimeLimitInput";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import YuJaDateTimePicker from "../../components/YuJaDateTimePicker";
import YuJaSwitch from "../../components/standardization/YuJaSwitch";
import {Button} from "@base-ui/react/button";
import YuJaSelect from "../../components/standardization/YuJaSelect";


export default function ViewReleaseOptions({setPageView, pollData, handleShareAll, handleOpen, resetPollData}) {
    const {pollKey, pollCode} = useParams();
    const {editPublishedPollDataFromKey, publishPoll, updatePollDetails} = PollApiCalls();
    const {embedActivity, isLMSAuthorized} = LTIApiCalls();
    const {takeScreenshotsNew} = ReportApiCalls();
    const [, getSession] = useLocalStorageNew("session", {});
    const {getRedirectUrl} = useSynLMSConfiguration();
    const session = getSession();
    const {settings = {}, } = session;
    const userSettings = transferUserSettings(settings);

    const {poll={}, questions=[]} = pollData;

    const {share, pollShareMode, startTime, endTime, index2Pk, reminderTime, pollType} = poll;
    let shareModeOptionDisabled = pollShareMode !== POLL_SHARE_MODE.UNKNOWN;

    const [shareMode, setShareMode] = useState(pollType === POLL_TYPE.ATTENDANCE ? POLL_SHARE_MODE.SHARE_EACH : pollShareMode);
    // const [pollTimeLimit, setPollTimeLimit] = useState(
    //     pollType === POLL_TYPE.ATTENDANCE
    //         ? timeSecondsToCustomNew(poll.attendanceDuration)
    //         : timeSecondsToCustomNew(poll.pollTimeLimit)
    // );

    const [pollTimeLimit, setPollTimeLimit] = useState(
        pollType === POLL_TYPE.ATTENDANCE
            ? poll.attendanceDuration
            : (
                pollShareMode === POLL_SHARE_MODE.SCHEDULE
                    ? (!!poll.pollTimeLimit
                            ? poll.pollTimeLimit
                            : userSettings[USER_SETTINGS.POLL_DURATION]
                    )
                    : poll.pollTimeLimit
            )
    );

    const [pollCountDown, setPollCountDown] = useState(
        pollType !== POLL_TYPE.ATTENDANCE
            ? (!!poll.getReadyAllTimeLimit ? poll.getReadyAllTimeLimit : userSettings[USER_SETTINGS.POLL_COUNTDOWN])
            : 0
    );
    const [isUnlimitedTime, setIsUnlimitedTime] = useState(poll.manualEnd === "true" || poll.manualEnd === true);
    const getNow = () => {
        let now = new Date();
        const minutes = now.getMinutes();
        const minutesToAdd = 5 - (minutes % 5);
        now.setSeconds(0);
        now.setMilliseconds(0);
        now.setMinutes(minutes + minutesToAdd);
        return now.getTime();
    }

    const [startDate, setStartDate] = useState(
        startTime
            ? new Date(startTime)
            : new Date(getNow() + 1800 * 1000 )
    );
    const [endDate, setEndDate] = useState(
        endTime
            ? new Date(endTime)
            : new Date(getNow() + 1800 * 1000 + poll.pollTimeLimit * 1000)
    );
    const [notificationTime, setNotificationTime] = useState(
        !!reminderTime && reminderTime !== -1
            ? (new Date(startTime).getTime() - new Date(reminderTime).getTime()) / 1000
            : -1
    );
    const [enableNotification, setEnableNotification] = useState(notificationTime !== -1);
    const [isSubmitting, setIsSubmitting] = useState(false);
    // const [manualEnd, setManualEnd] = useState(poll.manualEnd === "true" || poll.manualEnd === true)



    const btnStyle = {width: 80, height: 35, display: "flex", alignItems: "center", justifyContent: "center"};


    const choosePollShareMode = (pollShareMode) => {

        if (!shareModeOptionDisabled) {
            setShareMode(pollShareMode);
        }
    }

    const embed = async () => {
        let isSuccess = await embedActivity(pollKey, pollCode);
        if (isSuccess) {
            let copy = JSON.parse(JSON.stringify(poll));
            copy.pollShareMode = shareMode;
            let isMultipleSlides = isShareByQuestionActivity(copy);
            takeScreenshotsNew(
                pollKey,
                pollCode,
                isMultipleSlides,
                Array.from({ length: questions.length }, (_, i) => ({ serialNo: i + 1 }))
            );
        }
    }

    const handleSubmit = async () => {
        let pollToAdd = { ...pollData };
        let timeLimit = isUnlimitedTime ? 0 : pollTimeLimit;

        setIsSubmitting(true);


        try {
            let authorized = await isLMSAuthorized();
            if (!authorized) {
                return;
            }

            if (pollType === POLL_TYPE.ATTENDANCE) {
                await embed();
                await handleOpen(timeLimit);
            } else if (shareMode === POLL_SHARE_MODE.SHARE_ALL) { // shareAll
                await embed();
                await handleShareAll(timeLimit, pollCountDown);
            } else if (shareMode === POLL_SHARE_MODE.SCHEDULE) { // schedule
                let isAlreadyStarted = new Date(startTime) < new Date();
                pollToAdd.pollKey = pollKey;
                pollToAdd.pollShareMode = POLL_SHARE_MODE.SCHEDULE;
                pollToAdd.manualEnd = false;


                let body = {};
                if (!startDate && !endDate) {
                    notifyError(MISSING_SCHEDULE_START_END_TIME_ERROR);
                    return;
                }
                if (endDate < startDate) {
                    notifyError(INVALID_SCHEDULE_END_DATE_ERROR);
                    return;
                }
                if (endDate < new Date()) {
                    notifyError(INVALID_SCHEDULE_END_TIME_ERROR);
                    return;
                }
                if (!isAlreadyStarted && startDate < new Date()) {
                    notifyError(INVALID_SCHEDULE_START_TIME_ERROR);
                    return;
                }
                if (endDate > startDate.getTime() + 30 * 24 * 60 * 60 * 1000) {
                    notifyError(SCHEDULE_POLL_START_END_GAP_ERROR);
                    return;
                }
                body.startTime = startDate;
                body.endTime = endDate;

                if ((endDate - startDate) / 1000 < pollTimeLimit) {
                    notifyError(INVALID_TIME_LIMIT_ERROR);
                    return;
                }
                body.pollTimeLimit = pollTimeLimit;


                // const timeToStart = startDate - new Date();
                // if (notificationTime && timeToStart < notificationTime * 1000) {
                //     notifyError(PAST_NOTIFICATION_ERROR);
                //     return;
                // }
                body.reminderTime = notificationTime ? notificationTime : -1;
                body.shortName = getShortName();

                if (pollShareMode === POLL_SHARE_MODE.UNKNOWN) {
                    pollToAdd = {...pollToAdd, ...body}
                    await publishPoll(pollToAdd);
                } else {
                    await editPublishedPollDataFromKey(body, pollKey, pollCode);
                }
                notifySuccess("Poll have been successfully updated.")
                await embed();
                resetPollData(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW);
            } else { // shareEach
                await updatePollDetails(pollKey, pollCode, {pollShareMode: POLL_SHARE_MODE.SHARE_EACH}, true);
                await embed();
                resetPollData(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW);
            }
        } finally {
            setIsSubmitting(false);
        }

    };



    if (pollType === POLL_TYPE.ATTENDANCE) {
        return (
            <div className={classes.parentContainer}>
                <div className={classes.mainCard} style={{padding: 0, gap: 0}}>
                    <div className={classes.column} style={{padding: 20, flex: 1, minHeight: 0, overflowY: 'auto'}}>
                        <span
                            tabIndex={0}
                            style={{cursor: "pointer", display: "flex", alignItems: "center", width: "fit-content", marginBottom: 20}}
                            onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW)}
                        >
                            <BACK style={{marginRight: 2}}/>
                            <span>{BACK_TEXT}</span>
                        </span>

                        <div className={classes.column} style={{alignSelf: "center", maxWidth: "min(900px, 100%)"}}>
                            <span className={classes.description} style={{marginTop: 35, marginBottom: 20}}>
                                {RELEASE_ACTIVITY_OPTIONS_DESCRIPTION.replaceAll(
                                    ACTIVITY_TYPE_PLACEHOLDER,
                                    pollType === POLL_TYPE.ATTENDANCE
                                        ? deCapitalizeWord(ATTENDANCE)
                                        : deCapitalizeWord(POLL_TEXT)
                                )}
                            </span>

                            <div className={classes.row}>
                                <div className={classes.column}>
                                    <div className={settingsClasses.settingLabel} id={"unlimited-attendance-time"}>{ATTENDANCE_LENGTH_SETTING_TEXT}</div>
                                    <div className={settingsClasses.settingDescription}>{ATTENDANCE_LENGTH_SETTING_DESC}</div>
                                </div>
                                <div style={{flex: 1}}/>
                                <YuJaSwitch
                                    aria-label={ATTENDANCE_LENGTH_SETTING_TEXT}
                                    checked={isUnlimitedTime}
                                    onChange={checked => {
                                        if (!!checked) {
                                            setPollTimeLimit(0);
                                        } else {
                                            setPollTimeLimit(!!poll.attendanceDuration
                                                ? poll.attendanceDuration
                                                : userSettings[USER_SETTINGS.ATTENDANCE_DURATION]);
                                        }
                                        setIsUnlimitedTime(checked);
                                    }}
                                />
                            </div>


                            {!isUnlimitedTime &&
                                <div className={classes.row} style={{gap: 20, alignItems: "end", marginTop: 15}}>
                                    <div className={classes.column} style={{flex: 1, minWidth: 0}}>
                                        <div className={settingsClasses.settingLabel}>{ATTENDANCE_TIME_LIMIT_TEXT}</div>
                                        <span className={settingsClasses.settingDescription}>
                                            {PARTICIPANT_TIME_INTRO.replaceAll(
                                                ACTIVITY_TYPE_PLACEHOLDER,
                                                pollType === POLL_TYPE.ATTENDANCE
                                                    ? deCapitalizeWord(ATTENDANCE)
                                                    : deCapitalizeWord(POLL_TEXT)
                                            )}
                                        </span>
                                    </div>
                                    <TimeLimitInput
                                        label={ATTENDANCE_TIME_LIMIT_TEXT}
                                        timeLimit={pollTimeLimit}
                                        setTimeLimit={(timeLimit) => {
                                            setPollTimeLimit(timeLimit);
                                            if (!timeLimit) {
                                                setIsUnlimitedTime(true);
                                            }
                                        }}
                                        unit={"HH:MM"}
                                    />
                                </div>
                            }
                        </div>


                    </div>

                    <div
                        className={classes.row}
                        style={{gap: 10, height: 65, width: "100%", padding: "0 20px", borderTop: "1px solid #D1D1D1"}}
                    >
                        <span style={{flex: 1}}/>
                        <YuJaButton
                            type={"secondary"}
                            style={btnStyle}
                            onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW)}
                        >{MODAL_CANCEL_TEXT}</YuJaButton>
                        <YuJaButton
                            disabled={!shareMode || shareMode === POLL_SHARE_MODE.UNKNOWN || isSubmitting}
                            style={btnStyle}
                            onClick={handleSubmit}
                        >
                            <span className={`${isSubmitting ? classes.precessingText : ""}`}>{RELEASE.trim()}</span>
                        </YuJaButton>

                    </div>

                </div>
            </div>
        );
    }


    if (shareMode === POLL_SHARE_MODE.SCHEDULE) {
        let isStarted = startDate < new Date();
        let filteredReminderOptions = EMAIL_NOTIFICATION_OPTIONS;


        const inCourse = !!index2Pk;

        return (
            <div className={classes.parentContainer}>
                <div className={classes.mainCard} style={{padding: 0, gap: 0}}>
                    <div className={classes.column} style={{padding: 20, flex: 1, minHeight: 0, overflowY: 'auto'}}>
                        <span
                            tabIndex={0}
                            style={{cursor: "pointer", display: "flex", alignItems: "center", width: "fit-content", marginBottom: 20}}
                            onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW)}
                        >
                            <BACK style={{marginRight: 2}}/>
                            <span>{BACK_TEXT}</span>
                        </span>

                        <div className={classes.column} style={{alignSelf: "center", maxWidth: "min(900px, 100%)"}}>
                            <div
                                className={classes.row}
                                style={{
                                    alignSelf: "center",
                                    gap: 15,
                                    marginBottom: 35
                                }}
                            >
                                <span className={classes.plusIconWrapper}><RELEASE_ICON/></span>
                                <span className={classes.title}>
                                    {inCourse
                                        ? SCHEDULED_RELEASE_OPTION_DESCRIPTION_WITH_EMAIL
                                        : SCHEDULED_RELEASE_OPTION_DESCRIPTION_WITHOUT_EMAIL
                                    }
                                </span>
                            </div>


                            <div className={classes.row} style={{flexWrap: "wrap", rowGap: 10, columnGap: 40}}>
                                <div className={classes.column} style={{flex: 1, minWidth: 150}}>
                                    <div className={settingsClasses.settingLabel}>{"Date and Time"}</div>
                                    <div className={settingsClasses.settingDescription} >
                                        {"Choose the start and end times for participants to join the poll."}
                                    </div>
                                </div>


                                <div className={classes.row} style={{gap: 5}}>
                                    <YuJaDateTimePicker
                                        ariaLabel={"Scheduled Poll start date time picker"}
                                        date={startDate}
                                        minDate={new Date(getNow())}
                                        maxDate={endDate}
                                        onChange={value => {
                                            if (!!value) {
                                                setStartDate(value);
                                            } else {
                                                setStartDate(null);
                                            }
                                        }}
                                    />
                                    <ARROW_RIGHT/>
                                    <YuJaDateTimePicker
                                        ariaLabel={"Scheduled Poll end date time picker"}
                                        date={endDate}
                                        minDate={startDate}
                                        onChange={value => {
                                            if (!!value) {
                                                setEndDate(value);
                                            } else {
                                                setEndDate(null);
                                            }
                                        }}
                                    />
                                </div>


                            </div>


                            <div style={{height: 20}}/>

                            <div className={classes.row}
                                 style={{flexWrap: "wrap", rowGap: 10, columnGap: 40, alignItems: "end"}}>
                                <div className={classes.column} style={{flex: 1, minWidth: 150}}>
                                    <div className={settingsClasses.settingLabel}>{POLL_TIME_LIMIT_TEXT}</div>
                                    <span className={settingsClasses.settingDescription}>
                                        {PARTICIPANT_TIME_INTRO_SCHEDULE}
                                    </span>
                                </div>
                                <TimeLimitInput
                                    timeLimit={pollTimeLimit}
                                    setTimeLimit={setPollTimeLimit}
                                    minVal={MINIMUM_POLL_TIME_LIMIT}
                                    reachMinValErrorText={MINIMUM_POLL_TIME_LIMIT_SETTING_ERROR}
                                    unit={"HH:MM"}
                                />
                            </div>


                            {inCourse &&
                                <div className={classes.column} style={{gap: 10, position: "relative"}}>

                                    {!!isStarted &&
                                        <YuJaTooltip
                                            tooltipStyle={{minWidth: 200, maxWidth: 350}}
                                            text={SCHEDULED_POLL_EMAIL_NOTIFICATION_DISABLED_REASON}
                                        >
                                            <div
                                                style={{
                                                    position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
                                                    background: "#E6E6E6", opacity: 0.5,
                                                    cursor: "not-allowed", zIndex: 1
                                                }}
                                            />
                                        </YuJaTooltip>
                                    }
                                    <div className={classes.row} style={{marginTop: 20}}>
                                        <div className={classes.column}>
                                            <div className={settingsClasses.settingLabel}>{"Email Notifications"}</div>
                                            <div className={settingsClasses.settingDescription}>
                                                {"Notify participants by email at least 15 minutes before the poll releasing."}
                                            </div>
                                        </div>

                                        <div style={{flex: 1}}/>

                                        <YuJaSwitch
                                            aria-label={EMAIL_NOTIFICATIONS}
                                            disabled={isStarted}
                                            checked={enableNotification}
                                            onChange={checked => {
                                                setEnableNotification(checked);
                                                if (checked) {
                                                    setNotificationTime(filteredReminderOptions[0].value);
                                                }
                                            }}
                                        />
                                    </div>

                                    {!!filteredReminderOptions.length && enableNotification &&
                                        <YuJaSelect
                                            ariaLabel={EMAIL_NOTIFICATIONS_TIMER}
                                            value={notificationTime === -1 ? "" : notificationTime}
                                            options={filteredReminderOptions}
                                            disabled={isStarted}
                                            onChange={val => setNotificationTime(val)}
                                        />
                                        // <YuJaDropdown
                                        //     containerStyle={{width: 120}}
                                        //     size={YUJA_DROPDOWN_SIZE.SMALL}
                                        //     data={filteredReminderOptions}
                                        //     value={notificationTime === -1 ? "" : notificationTime}
                                        //     disabled={isStarted}
                                        //     onChange={option => {
                                        //         setNotificationTime(option.value);
                                        //     }}
                                        //     placeholder={NOTIFICATION_DROPDOWN_PLACEHOLDER}
                                        // />
                                    }
                                </div>
                            }


                        </div>
                    </div>


                    <div
                        className={classes.row}
                        style={{gap: 10, height: 65, width: "100%", padding: "0 20px", borderTop: "1px solid #D1D1D1"}}
                    >
                        <span style={{flex: 1}}/>
                        <YuJaButton
                            type={"secondary"}
                            style={btnStyle}
                            onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW)}
                        >{"Cancel"}</YuJaButton>
                        <YuJaButton
                            style={btnStyle}
                            disabled={isSubmitting}
                            onClick={handleSubmit}
                        >
                            <span className={`${isSubmitting ? classes.precessingText : ""}`}>{SCHEDULE}</span>
                        </YuJaButton>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div className={classes.parentContainer}>
            <div className={classes.mainCard} style={{padding: 0, gap: 0}}>
                <div className={classes.column} style={{padding: 20, flex: 1, minHeight: 0, overflowY: 'auto'}}>
                    <span
                        tabIndex={0}
                        style={{cursor: "pointer", display: "flex", alignItems: "center", width: "fit-content", marginBottom: 20}}
                        onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW)}
                    >
                        <BACK style={{marginRight: 2}}/>
                        <span>{BACK_TEXT}</span>
                    </span>

                    <div className={classes.column} style={{alignSelf: "center", maxWidth: "min(900px, 100%)"}}>
                        <div
                            className={classes.row}
                            style={{
                                alignSelf: "center",
                                gap: 15,
                                marginBottom: 35
                            }}
                        >
                            <span className={classes.plusIconWrapper}><RELEASE_ICON/></span>
                            <h1 className={classes.title} style={{margin: 0}}>{"How would you like to release the poll?"}</h1>
                        </div>


                        {shareModeOptionDisabled &&
                            <div className={classes.disabledNotification} style={{marginTop: 20}}>
                                <INFO_ICON className={classes.infoIcon} style={{flexShrink: 0}}/>
                                <span>
                                    <span className={classes.title} style={{marginRight: 5}}>
                                        {"Editing Disabled:"}
                                    </span>
                                    <span>
                                        {"Release option cannot be edited once you selected the release option."}
                                    </span>
                                </span>
                            </div>
                        }


                        <div style={{display: "flex", gap: 40}}>
                            <Button
                                disabled={shareModeOptionDisabled}
                                className={`
                                ${classes.releaseOptionCard} 
                                ${shareMode === POLL_SHARE_MODE.SHARE_ALL ? classes.active : ""}
                                ${shareModeOptionDisabled ? classes.disabled : ""}
                                `}
                                onClick={() => choosePollShareMode(POLL_SHARE_MODE.SHARE_ALL)}
                            >
                                <RELEASE_ENTIRELY_IMAGE style={{marginBottom: 15, flexShrink: 0}}/>
                                <span className={classes.title}
                                      style={{textAlign: "center"}}>{"Release All Questions"}</span>
                                <span className={classes.description}
                                      style={{textAlign: "center"}}>{"Release all questions to participants at once."}</span>
                            </Button>

                            <Button
                                disabled={shareModeOptionDisabled}
                                className={`
                                ${classes.releaseOptionCard} 
                                ${shareMode === POLL_SHARE_MODE.SHARE_EACH ? classes.active : ""}
                                ${shareModeOptionDisabled ? classes.disabled : ""}
                                `}
                                onClick={() => choosePollShareMode(POLL_SHARE_MODE.SHARE_EACH)}
                            >
                                <RELEASE_BY_QUESTION_IMAGE style={{marginBottom: 15, flexShrink: 0}}/>
                                <span className={classes.title}
                                      style={{textAlign: "center"}}>{"Release Question by Question"}</span>
                                <span className={classes.description}
                                      style={{textAlign: "center"}}>{"Release questions one at a time to participants."}</span>
                            </Button>

                            <Button
                                disabled={shareModeOptionDisabled}
                                className={`
                                ${classes.releaseOptionCard} 
                                ${shareMode === POLL_SHARE_MODE.SCHEDULE ? classes.active : ""}
                                ${shareModeOptionDisabled ? classes.disabled : ""}
                                `}
                                onClick={() => choosePollShareMode(POLL_SHARE_MODE.SCHEDULE)}
                            >
                                <RELEASE_SCHEDULED_IMAGE style={{marginBottom: 15, flexShrink: 0}}/>
                                <span className={classes.title}
                                      style={{textAlign: "center"}}>{"Schedule Release"}</span>
                                <span className={classes.description}
                                      style={{textAlign: "center"}}>{"Schedule the poll to be released at a later date and time."}</span>
                            </Button>
                        </div>

                        {shareMode === POLL_SHARE_MODE.SHARE_ALL &&
                            <>
                                <span
                                    className={classes.description}
                                    style={{marginTop: 35, marginBottom: 20}}
                                >
                                    {RELEASE_ACTIVITY_OPTIONS_DESCRIPTION.replaceAll(
                                        ACTIVITY_TYPE_PLACEHOLDER,
                                        pollType === POLL_TYPE.ATTENDANCE
                                            ? deCapitalizeWord(ATTENDANCE)
                                            : deCapitalizeWord(POLL_TEXT)
                                    )}
                                </span>

                                <div className={classes.row}>
                                    <div className={classes.column}>
                                        <div className={settingsClasses.settingLabel} >{POLL_LENGTH_SETTING_TEXT}</div>
                                        <div
                                            className={settingsClasses.settingDescription}>{POLL_LENGTH_SETTING_DESC}</div>
                                    </div>
                                    <div style={{flex: 1}}/>


                                    <YuJaSwitch
                                        aria-label={POLL_LENGTH_SETTING_TEXT}
                                        checked={isUnlimitedTime}
                                        onChange={checked => {
                                            if (!!checked) {
                                                setPollTimeLimit(0);
                                            } else {
                                                setPollTimeLimit(!!poll.pollTimeLimit ? poll.pollTimeLimit : userSettings[USER_SETTINGS.POLL_DURATION]);
                                            }
                                            setIsUnlimitedTime(checked);
                                        }}
                                    />
                                </div>


                                {!isUnlimitedTime &&
                                    <div className={classes.row} style={{gap: 20, alignItems: "end", marginTop: 15}}>
                                        <div className={classes.column} style={{flex: 1, minWidth: 0}}>
                                            <div className={settingsClasses.settingLabel}>{POLL_TIME_LIMIT_TEXT}</div>
                                            <span className={settingsClasses.settingDescription}>
                                                {PARTICIPANT_TIME_INTRO.replaceAll(
                                                    ACTIVITY_TYPE_PLACEHOLDER,
                                                    pollType === POLL_TYPE.ATTENDANCE
                                                        ? deCapitalizeWord(ATTENDANCE)
                                                        : deCapitalizeWord(POLL_TEXT)
                                                )}
                                            </span>
                                        </div>
                                        <TimeLimitInput
                                            label={POLL_TIME_LIMIT_TEXT}
                                            timeLimit={pollTimeLimit}
                                            setTimeLimit={(timeLimit) => {
                                                setPollTimeLimit(timeLimit);
                                                if (!timeLimit) {
                                                    setIsUnlimitedTime(true);
                                                }
                                            }}
                                            unit={"HH:MM"}
                                        />
                                    </div>
                                }


                                <div className={classes.row} style={{marginTop: 20, gap: 20}}>
                                    <div className={classes.column} style={{flex: 1, minWidth: 0}}>
                                        <div className={settingsClasses.settingLabel}>{COUNTDOWN_TIMER_LABEL}</div>
                                        <div className={settingsClasses.settingDescription}>
                                            {POLL_COUNTDOWN_TIMER_DESCRIPTION}
                                            {!getRedirectUrl(poll) && poll.syncLmsOption === SYNC_LMS_OPTIONS.LMS_API_SYNC &&
                                                <> {" " + POLL_COUNTDOWN_TIMER_EMPHASIS}</>
                                            }

                                        </div>
                                    </div>

                                    <TimeLimitInput
                                        label={COUNTDOWN_TIMER_LABEL}
                                        timeLimit={pollCountDown}
                                        setTimeLimit={(timeLimit) => {
                                            setPollCountDown(timeLimit);
                                        }}
                                        unit={"MM:SS"}
                                        minVal={DEFAULT_COUNT_DOWN_TIME_LIMIT}
                                        reachMinValErrorText={MINIMUM_COUNT_DOWN_SETTING_ERROR}
                                    />
                                </div>
                            </>
                        }
                    </div>


                </div>

                <div
                    className={classes.row}
                    style={{gap: 10, height: 65, width: "100%", padding: "0 20px", borderTop: "1px solid #D1D1D1"}}
                >
                    <span style={{flex: 1}}/>
                    <YuJaButton
                        type={"secondary"}
                        style={btnStyle}
                        onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW)}
                    >{"Cancel"}</YuJaButton>
                    <YuJaButton
                        disabled={!shareMode || shareMode === POLL_SHARE_MODE.UNKNOWN || isSubmitting}
                        style={btnStyle}
                        onClick={handleSubmit}
                    >
                        <span className={`${isSubmitting ? classes.precessingText : ""}`}>{RELEASE.trim()}</span>
                    </YuJaButton>

                </div>
            </div>
        </div>
    )
        ;
}